export const key = 'login';

type HostNameType = 'SG' | 'EU' | 'IN';

export type TokenResponseType = {
    user_pod: HostNameType;
    api_key_count: string;
    api_key_sid: string;
    api_key: string;	
    accessToken:string;
    refreshToken:string;
};

export type LoginType = {
    success: boolean;
    valid: boolean;
}

export type GlobalStore = {
    [key]: LoginType;
  }

export const initialState: LoginType = {
    success: false,
    valid: false
}